import * as React from "react";
import styled from "styled-components";
import i18n from "i18n";
import { Alert } from "components/bootstrap";
import { SortableList } from "components/common";
import DecoratorStyles from "./decoratorStyles.css";
const AlertContainer = styled.div`
  margin-bottom: 20px;
`;
class DecoratorList extends React.Component {
  constructor() {
    super(...arguments);
    this._onReorderWrapper = (orderedItems) => {
      const { onReorder } = this.props;
      onReorder(orderedItems);
    };
  }
  render() {
    const { decorators, disableDragging } = this.props;
    if (!decorators || decorators.length === 0) {
      return /* @__PURE__ */ React.createElement(AlertContainer, null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info", className: DecoratorStyles.noDecoratorsAlert }, i18n.t("message_table.decorators.none_configured", { ns: "widgets" })));
    }
    return /* @__PURE__ */ React.createElement(
      SortableList,
      {
        items: decorators,
        onMoveItem: this._onReorderWrapper,
        disableDragging,
        displayOverlayInPortal: true
      }
    );
  }
}
DecoratorList.defaultProps = {
  disableDragging: false,
  onReorder: () => {
  }
};
export default DecoratorList;
